import { ServicePrimaryTag } from "entities/tagTypes/types";
import { collection, getDocs, orderBy, query } from "firebase/firestore";
import { db } from "shared/api/firebase";
import { TagTypeDB } from "./TagType";

export const getServicePrimaryTagList = async (): Promise<ServicePrimaryTag[]> => {
  const tagTypesRef = collection(db, "tagTypes");

  const q = query(tagTypesRef, orderBy("name", "asc"));
  const tagTypesSnapshot = await getDocs(q);
  return tagTypesSnapshot.docs.map((doc) => new TagTypeDB(doc).toTagType());
};
